//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FactorQualifiedDrawer from "./modules/FactorQualifiedDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@api/manage';
export default {
  name: "FactorQualifiedList",
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    FactorQualifiedDrawer: FactorQualifiedDrawer
  },
  data: function data() {
    return {
      pagePath: '/site/factor/qualified',
      pageTitle: '因子合格范围',
      addDisabled: false,
      siteName: '',
      siteFactorList: [],
      url: {
        querySiteFactor: "/site/factor/qualified/querySiteFactor/"
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'factorName',
        colName: 'factorId',
        title: '因子',
        align: "center"
      }, {
        dataIndex: 'dataType_dictText',
        colName: 'data_type',
        title: '数据类型',
        align: "center"
      }, {
        dataIndex: 'timeType_dictText',
        colName: 'time_type',
        title: '时间类型',
        align: "center"
      }, {
        dataIndex: 'mistakeType_dictText',
        colName: 'mistake_type',
        title: '误差类型',
        align: "center"
      }, {
        dataIndex: 'errorValue',
        colName: 'error_value',
        title: '误差值',
        align: "center",
        customRender: function customRender(t, r, index) {
          return r.mistakeType == 2 ? '±' + r.errorValue + '%' : '±' + r.errorValue;
        }
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.loadSiteFactorList(this.queryParam.siteId);
      this.delayLoadData();
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    handleAdd: function handleAdd() {
      var siteId = this.queryParam.siteId;
      this.$refs.modalForm.add(siteId);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    loadSiteFactorList: function loadSiteFactorList(params) {
      var that = this;
      that.siteFactorList = [];
      getAction(this.url.querySiteFactor + params).then(function (res) {
        if (res.success) {
          that.siteFactorList = res.result;
        }
      });
      this.loadData();
    }
  }
};